import { Injectable } from '@angular/core';
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from '../../common/providers/api-base-service';
import { CurrentUser } from "../../common/providers/current-user";
import { LangsProvider } from '../../common/providers/langs-provider';
import { Notification } from "../../common/models/notification";
import { Observable, switchMap } from "rxjs";
import { map } from "rxjs/operators";
import { Paginator } from "../../common/models/paginator";


@Injectable({providedIn: 'root'})
export class NotificationsProvider {
  private _notifications: Notification[] = [];
  public get notifications() {
    return this._notifications;
  }

  private _unSeenNotifications: Notification[] = [];
  public get unSeenNotifications() {
    return this._unSeenNotifications;
  }

  constructor(
    private _utils: UtilsProvider,
    private _api: ApiBaseService,
    private _langsProvider: LangsProvider,
    private _currentUser: CurrentUser,
  ) {
    this.updateNotifications().subscribe();
  }


  public markSeen(notifications: Notification[]): Observable<void> {
    return this._api.call(                'post',
      'notifications/mark-seen',
      { notificationIds: this._utils.getKeyValues(notifications) },
      this._currentUser.getAccessToken()
    ).pipe(
      switchMap(() => {
        return this.updateNotifications();
      })
    );
  }

  public updateNotifications(): Observable<void> {
    return this._api.call('get', 'notifications', {unread: true}, this._currentUser.getAccessToken())
      .pipe(
        map((notifications: Notification[]) => {
          this._notifications = notifications;
          this._unSeenNotifications = [];
          this._notifications.forEach((notification: Notification) => {
            if (!notification.read_at) {
              this._unSeenNotifications.push(notification);
            }
          });
        })
      );
  }
}
